import { ComponentUITypes, DefaultModelProperty, LabelValue } from '../standard'
import Media from './media-model'
import mediaProperties from './media-properties'
import { MediaProperties } from './media-property-definitions'

import { Rating } from '../enumerations'
export async function OnEvents(
  eventType: string,
  form: Media,
  property: MediaProperties,
): Promise<Media> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: MediaProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: MediaProperties): boolean {
  switch (property) {
    case MediaProperties.Name:
      return false
    case MediaProperties.MediaType:
      return false
    case MediaProperties.Owner:
      return false
    case MediaProperties.Id:
      return false
    case MediaProperties.Created:
      return false
    case MediaProperties.Updated:
      return false
    case MediaProperties.Deleted:
      return false
    case MediaProperties.Version:
      return false
    case MediaProperties.Profile:
      return false
    case MediaProperties.IsPrivate:
      return false
    case MediaProperties.Restrictions:
      return false
    case MediaProperties.Likes:
      return false
    case MediaProperties.MediaStatus:
      return false
    case MediaProperties.Processed:
      return false
    case MediaProperties.Published:
      return false
    case MediaProperties.Released:
      return false
    case MediaProperties.Description:
      return false
    case MediaProperties.MediaInformation:
      return false
    case MediaProperties.MediaReactions:
      return false
    case MediaProperties.Tag:
      return false
    case MediaProperties.Thumbnails:
      return false
    case MediaProperties.TransparentTitleLocation:
      return false
    case MediaProperties.MediaRelLocation:
      return false
    case MediaProperties.ThumbnailLocation:
      return false
    case MediaProperties.MediaPreviewLocation:
      return false
    case MediaProperties.MediaPreviewDuration:
      return false
    case MediaProperties.MediaDuration:
      return false
    case MediaProperties.HasProcessed:
      return false
    default:
      return true
  }
}
async function change(property: MediaProperties, value: Media): Promise<Media> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<MediaProperties>[] {
  return mediaProperties as DefaultModelProperty<MediaProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<MediaProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      case MediaProperties.Name:
        return 5
      case MediaProperties.Description:
        return 7
      case MediaProperties.Tag:
        return 9
      case MediaProperties.Rating:
        return 5
      case MediaProperties.MinimumAppropriateAge:
        return 5
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<MediaProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<MediaProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(property: MediaProperties): LabelValue<any>[] {
  switch (property) {
    case MediaProperties.Rating:
      return Object.entries(Rating).map((v) => {
        return {
          label: v[0],
          value: v[1],
        }
      })
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: MediaProperties): boolean {
  switch (property) {
    case MediaProperties.Name:
      return false
    case MediaProperties.MediaType:
      return false
    case MediaProperties.Owner:
      return false
    case MediaProperties.Id:
      return false
    case MediaProperties.Created:
      return false
    case MediaProperties.Updated:
      return false
    case MediaProperties.Deleted:
      return false
    case MediaProperties.Version:
      return false
    case MediaProperties.Profile:
      return false
    case MediaProperties.IsPrivate:
      return false
    case MediaProperties.Restrictions:
      return false
    case MediaProperties.Likes:
      return false
    case MediaProperties.MediaStatus:
      return false
    case MediaProperties.Description:
      return false
    case MediaProperties.MediaInformation:
      return false
    case MediaProperties.MediaReactions:
      return false
    case MediaProperties.Tag:
      return false
    case MediaProperties.Thumbnails:
      return false
    case MediaProperties.Published:
      return false
    case MediaProperties.Released:
      return false
    case MediaProperties.TransparentTitleUrl:
      return false
    case MediaProperties.Rating:
      return false
    case MediaProperties.TransparentTitleLocation:
      return false
    case MediaProperties.MediaRelLocation:
      return false
    case MediaProperties.Thumbnail:
      return false
    case MediaProperties.ThumbnailLocation:
      return false
    case MediaProperties.MediaPreviewUrl:
      return false
    case MediaProperties.MediaPreviewLocation:
      return false
    case MediaProperties.MediaPreviewDuration:
      return false
    case MediaProperties.MediaDuration:
      return false
    case MediaProperties.HasProcessed:
      return false
    case MediaProperties.MinimumAppropriateAge:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<MediaProperties>[],
): DefaultModelProperty<MediaProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<MediaProperties>) => {
      switch (modelProperty.name) {
        case MediaProperties.Name:
          modelProperty.type = ComponentUITypes.STRING
          break
        case MediaProperties.Rating:
          modelProperty.type = ComponentUITypes.DROPDOWN
          break
        case MediaProperties.MinimumAppropriateAge:
          modelProperty.type = ComponentUITypes.NUMBER
          break
        default:
          switch (modelProperty.name) {
            case MediaProperties.MediaRel:
              modelProperty.type = 'view-media-video'

              break
            case MediaProperties.TransparentTitleUrl:
              modelProperty.type = 'view-media-thumbnail'

              break
            case MediaProperties.Thumbnail:
              modelProperty.type = 'view-media-thumbnail'

              break
            case MediaProperties.MediaPreviewUrl:
              modelProperty.type = 'view-media-video'

              break
            default:
              break
          }

          break
      }
      return modelProperty
    },
  )
}
